import Cookies from 'js-cookie';

import {
    getCat,
    getCell,
    getLgc,
    getSpid
} from './session-storage';

/**
 * Retrieves the current card member type from cookies. i.e. classic, premier, or inspire.
 * @returns The current card member type.
 */
function getCardMemberType() {
    return Cookies.get('disneyrewards-cardmember-type') || 'classic';
}

/**
 * Retrieves an array of replacement token patterns.
 * @param {string} value The replacement text value.
 * @returns An array of replacement token patterns.
 */
export function getReplacementPatterns(value) {
    return [`((${value}))`, `{${value}}`, encodeURIComponent(`((${value}))`), encodeURIComponent(`{${value}}`)];
}

export const replacementTokens = {
    cat: 'cat',
    catClassic: 'cat_classic',
    catPremier: 'cat_premier',
    catInspire: 'cat_inspire',
    cell: 'cell',
    lgc: 'lgc',
    lgcClassic: 'lgc_classic',
    lgcPremier: 'lgc_premier',
    lgcInspire: 'lgc_inspire',
    spid: 'spid',
    spidClassic: 'spid_classic',
    spidPremier: 'spid_premier',
    spidInspire: 'spid_inspire'
};

export default [
    // CAT
    {
        patterns: () => getReplacementPatterns(replacementTokens.cat),
        value: () => getCat()[getCardMemberType()]
    },
    // CAT Classic
    {
        patterns: () => getReplacementPatterns(replacementTokens.catClassic),
        value: () => getCat().classic
    },
    // CAT Premier
    {
        patterns: () => getReplacementPatterns(replacementTokens.catPremier),
        value: () => getCat().premier
    },
    // CAT Inspire
    {
        patterns: () => getReplacementPatterns(replacementTokens.catInspire),
        value: () => getCat().inspire
    },
    // CELL
    {
        patterns: () => getReplacementPatterns(replacementTokens.cell),
        value: () => getCell().value
    },
    // LGC
    {
        patterns: () => getReplacementPatterns(replacementTokens.lgc),
        value: () => getLgc()[getCardMemberType()]
    },
    // LGC Classic
    {
        patterns: () => getReplacementPatterns(replacementTokens.lgcClassic),
        value: () => getLgc().classic
    },
    // LGC Premier
    {
        patterns: () => getReplacementPatterns(replacementTokens.lgcPremier),
        value: () => getLgc().premier
    },
    // LGC Inspire
    {
        patterns: () => getReplacementPatterns(replacementTokens.lgcInspire),
        value: () => getLgc().inspire
    },
    // SPID
    {
        patterns: () => getReplacementPatterns(replacementTokens.spid),
        value: () => getSpid()[getCardMemberType()]
    },
    // SPID Classic
    {
        patterns: () => getReplacementPatterns(replacementTokens.spidClassic),
        value: () => getSpid().classic
    },
    // SPID Premier
    {
        patterns: () => getReplacementPatterns(replacementTokens.spidPremier),
        value: () => getSpid().premier
    },
    // SPID Inspire
    {
        patterns: () => getReplacementPatterns(replacementTokens.spidInspire),
        value: () => getSpid().inspire
    }
];
